import { Type, Injector } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { IMenuFilter, IFilterType } from '@nimbus-library/features/menu';
import { IPermissionManagerService } from '@nimbus-library/features/user-settings/services/contracts/i-permission-manager.service';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';

export class MenuFilterFactory {
  public createFilter$(filterDefinition: Type<IMenuFilter> | IFilterType | IMenuFilter, injector: Injector): Observable<boolean> {
    let type: Type<IMenuFilter>;
    let option: any;

    if (this.isInstanceOfFilter(filterDefinition)) {
      return filterDefinition.validate$();
    }

    if (this.isInstanceOfIFilterType(filterDefinition)) {
      type = filterDefinition.type;
      option = filterDefinition.option;
    } else {
      type = filterDefinition;
    }

    const filter = this.filterActivator(
      type,
      injector.get(Store),
      injector.get(IAuthenticationService),
      injector.get(IPermissionManagerService),
      injector,
    );
    return filter.validate$(option);
  }

  private filterActivator<T extends IMenuFilter>(
    type: new (...args: any[]) => T,
    store: Store,
    authenticationService: IAuthenticationService,
    permissionManagerService: IPermissionManagerService,
    injector: Injector,
  ): T {
    return new type(store, authenticationService, permissionManagerService, injector);
  }

  private isInstanceOfFilter(object: any): object is IMenuFilter {
    return 'validate$' in object;
  }

  private isInstanceOfIFilterType(object: any): object is IFilterType {
    return 'type' in object && 'option' in object;
  }
}
